import moment from "moment-timezone";

export const checkIfObject = (input) => {
	if (typeof input === "object" && input !== null && !Array.isArray(input)) {
		return true;
	} else return false;
};

export const checkIfArray = (input) => {
	if (typeof input === "object" && input !== null && Array.isArray(input)) {
		return true;
	} else return false;
};

export const checkIfObjectHasKeys = (input) => {
	if (checkIfObject(input)) {
		if (Object.entries(input).length > 0) return true;
		else return false;
	} else return false;
};

export const isDateAfter = (date1, date2) => {
	if (!date1 || !date2) return false;
	const date1Moment = moment(date1);
	const date2Moment = moment(date2);
	if (!date1Moment.isValid() || !date2Moment.isValid()) return false;
	return date1Moment.isAfter(date2Moment);
};
